(function() {
  'use strict';

  // Enable reveal animations only after JS is confirmed running
  document.documentElement.classList.add('js-reveal-ready');

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add('visible');
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

  const kitItems = document.querySelectorAll('.kit-item');
  const kitObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add('visible');
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  kitItems.forEach(item => kitObserver.observe(item));

  function updateNav() {
    // Nav stays visually consistent — no scroll-triggered changes
    var nav = document.getElementById('mainNav');
    if (nav) nav.classList.remove('scrolled');
  }

  const stickyBar = document.getElementById('stickyBar');
  const heroEl = document.getElementById('hero');
  const ctaEl = document.getElementById('waitlist');
  function updateStickyBar() {
    if (!heroEl || !ctaEl) return;
    const heroBot = heroEl.getBoundingClientRect().bottom;
    const ctaTop = ctaEl.getBoundingClientRect().top;
    stickyBar.classList.toggle('visible', heroBot < -100 && ctaTop > window.innerHeight + 60);
  }

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => { updateNav(); updateStickyBar(); ticking = false; });
      ticking = true;
    }
  }, { passive: true });
  updateNav(); updateStickyBar();

  window.togglePain = function(card) {
    const isOpen = card.classList.contains('open');
    document.querySelectorAll('.pain-card').forEach(c => {
      c.classList.remove('open'); c.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) { card.classList.add('open'); card.setAttribute('aria-expanded', 'true'); }
  };
})();